import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import PageHeader from "components/PageHeader/PageHeader";
import MotionSection from "components/MotionSection/MotionSection";
import SkeletonLoader from "components/SkeletonLoader/SkeletonLoader";
import { FC, useEffect, useState } from "react";
import { getCategories } from "data/api";

export interface ListingExperiencesPageProps {
  className?: string;
}

const CategoriesPage: FC<ListingExperiencesPageProps> = ({
  className = "",
}) => {
  const [demo_cats, setDemocats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategories().then((items) => {
      setDemocats(
        items.map((item: any) => ({
          id: item.id,
          name: item.title,
          thumbnail: item.image,
          taxonomy: "category",
          count: 2118,
          href: `/categories/${item.id}`,
        }))
      );
      setLoading(false);
    });
  }, []);

  return (
    <div
      className={`nc-ListingExperiencesPage relative overflow-hidden ${className}`}
      data-nc-id="ListingExperiencesPage"
    >
      <PageHeader
        title="Categories"
        subtitle="Explore our diverse selection of specialized construction solutions, built for durability, functionality, and aesthetic appeal."
      />

      <div className="container relative pb-20">
        <MotionSection className="relative py-8">
          {loading ? (
            <SkeletonLoader count={8} />
          ) : (
            <SectionSliderNewCategories
              heading=""
              subHeading=""
              categoryCardType="card4"
              itemPerRow={4}
              categories={demo_cats}
              sliderStyle="style2"
              uniqueClassName="ListingExperiencesPage"
            />
          )}
        </MotionSection>
      </div>
    </div>
  );
};

export default CategoriesPage;
